export enum DiscountRouteName {
  LISTING = 'listing',
  DETAIL = 'discount',
  CREATE = 'create-discount',
  DUPLICATE = 'duplicate-discount',
  UPDATE = 'update-discount',
  IMPORT_ASSOCIATION = 'import-discount-associations',
}
